import { GetStaticProps } from 'next'

import galleryCopy from '@/data/fixed-pages/copy-gallery'

import PageGallery, { PageGalleryProps } from '@/components/PageGallery/PageGallery'

export const getStaticProps: GetStaticProps<PageGalleryProps> = async () => {
  return {
    props: {
      head: { title: 'Gallery' },
      content: galleryCopy
    }
  }
}

export default PageGallery
